import Views from '../../views/host/hostRegistration/HostRegistrationViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import {
  ageGroupsIsComplete, eligibilityIsComplete, eventsIsComplete, meetInfoIsComplete, omeMeetsIsComplete,
  restrictionsIsComplete, sessionsIsComplete, submitIsComplete, timeStandardsIsComplete
}
  from './LeftNavValidation';

const getSubmit = (viewName, route, omeMeetStateObjData, orgUnitStateArrayData, meetStateObjData, omeMeetEntryStateObjData, TEAM_OME_FEE_TYPE_ID, CREDENTIAL_OME_FEE_TYPE_ID,
  INDIVIDUAL_ATHLETE_OME_FEE_TYPE_ID, INDIVIDUAL_INTL_ATHLETE_OME_FEE_TYPE_ID, INTL_STAFF_OME_FEE_TYPE_ID, RELAY_ONLY_SWIMMER_OME_FEE_TYPE_ID,
  ATHLETE_INDIVIDUAL_EVENT_ENTRY_OME_FEE_TYPE_ID, ATHLETE_INDIVIDUAL_BONUS_EVENT_ENTRY_OME_FEE_TYPE_ID, RELAY_EVENT_ENTRY_OME_FEE_TYPE_ID, FINA_ORG_UNIT_ID,
  ENTRY_CONTACT_STAFF_TYPE_ID, PAYMENT_CONTACT_STAFF_TYPE_ID, SCY_COURSE_ID, SCM_COURSE_ID, LCM_COURSE_ID, 
  restrictionsRoutePermission, eligibilityRoutePermission, meetInfoRoutePermission, omeMeetsDetailRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION) => {

  const isCurrent = ((viewName === Views.OME_MEET_SUBMIT) || (viewName === Views.OME_MEET_SUBMITTED)) === true ? true : false;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, meetInfoRoutePermission);
  const isEligibilityComplete = eligibilityIsComplete(omeMeetStateObjData, omeMeetEntryStateObjData, eligibilityRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION);
  const isRestrictionsComplete = restrictionsIsComplete(omeMeetStateObjData, restrictionsRoutePermission);
  const isSessionsComplete = sessionsIsComplete(meetStateObjData);
  const isAgeGroupsComplete = ageGroupsIsComplete(omeMeetStateObjData);
  const isTimeStandardsComplete = timeStandardsIsComplete(omeMeetStateObjData);
  const isEventsComplete = eventsIsComplete(omeMeetStateObjData, SCY_COURSE_ID, SCM_COURSE_ID, LCM_COURSE_ID);
  const isOmeMeetsComplete = omeMeetsIsComplete(omeMeetStateObjData, orgUnitStateArrayData, meetStateObjData, omeMeetEntryStateObjData, omeMeetsDetailRoutePermission, TEAM_OME_FEE_TYPE_ID, CREDENTIAL_OME_FEE_TYPE_ID,
    INDIVIDUAL_ATHLETE_OME_FEE_TYPE_ID, INDIVIDUAL_INTL_ATHLETE_OME_FEE_TYPE_ID, INTL_STAFF_OME_FEE_TYPE_ID, RELAY_ONLY_SWIMMER_OME_FEE_TYPE_ID,
    ATHLETE_INDIVIDUAL_EVENT_ENTRY_OME_FEE_TYPE_ID, ATHLETE_INDIVIDUAL_BONUS_EVENT_ENTRY_OME_FEE_TYPE_ID, RELAY_EVENT_ENTRY_OME_FEE_TYPE_ID, FINA_ORG_UNIT_ID);

  const arePrerequisitesDone = isMeetInfoComplete === true && isEligibilityComplete === true
    && isRestrictionsComplete === true && isSessionsComplete === true
    && isAgeGroupsComplete === true && isTimeStandardsComplete === true && isEventsComplete === true && isOmeMeetsComplete === true;

  const isComplete = isMeetInfoComplete === true && isEligibilityComplete === true && isTimeStandardsComplete === true && isEventsComplete === true && isOmeMeetsComplete === true && submitIsComplete(omeMeetStateObjData, meetStateObjData, ENTRY_CONTACT_STAFF_TYPE_ID, PAYMENT_CONTACT_STAFF_TYPE_ID);

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_SUBMIT) : getInitialStateMeetRoute(Views.OME_MEET_SUBMIT);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getSubmit;